import type { FarmState } from '../../domain/model';

export function analysisMetrics(state: FarmState) {
  const totalBorn = state.partos.reduce((sum, birth) => sum + birth.nacidosVivos, 0);
  const totalDeaths = state.mortalidad.reduce((sum, record) => sum + (record.cantidad || 1), 0);
  const prolificSows = state.cerdas.filter(sow => {
    const births = state.partos.filter(birth => birth.arete === sow.arete);
    return births.length > 0 && births.reduce((sum, birth) => sum + birth.nacidosVivos, 0) / births.length > 14;
  }).length;
  return {
    totalBorn,
    totalDeaths,
    totalSows: state.cerdas.length,
    pregnantSows: state.cerdas.filter(sow => sow.estado === 'preñada').length,
    emptySows: state.cerdas.filter(sow => sow.estado === 'vacía').length,
    totalBirths: state.cerdas.reduce((sum, sow) => sum + (sow.numPartos || 0), 0),
    averageBorn: state.partos.length ? (totalBorn / state.partos.length).toFixed(1) : '—',
    prolificSows,
    activeLots: state.lotes.filter(lot => lot.estado === 'activo').length,
    boars: state.verracos.length,
    mortalityPercent: totalBorn ? ((totalDeaths / totalBorn) * 100).toFixed(1) : '0',
    lotPerformance: state.lotes.filter(lot => state.alimentacion.some(record => record.loteId === lot.id)).map(lot => {
      const feed = state.alimentacion.filter(record => record.loteId === lot.id).reduce((sum, record) => sum + record.libras, 0);
      const gain = lot.historial.reduce((sum, record) => sum + ((record.pesoSalida || 0) - (record.pesoEntrada || 0)), 0);
      return { lotId: lot.id, feed, gain, conversion: gain > 0 ? (feed / gain).toFixed(2) : '—' };
    }),
    mortalityByStage: ['maternidad', 'destete', 'ceba'].map(stage => ({ stage, total: state.mortalidad.filter(record => record.etapa === stage).reduce((sum, record) => sum + (record.cantidad || 1), 0) })),
  };
}
